import { AlertCircle, Check } from 'lucide-react';

type Props = {
  error: string | null;
  success: string | null;
};

export default function DeviceLinkingMessages({ error, success }: Props) {
  if (!error && !success) {
    return null;
  }

  return (
    <>
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700">
          <AlertCircle className="w-5 h-5" />
          <span>{error}</span>
        </div>
      )}

      {success && (
        <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2 text-green-700">
          <Check className="w-5 h-5" />
          <span>{success}</span>
        </div>
      )}
    </>
  );
}

